import React from 'react';
import type { ComponentContentSchema } from '@vibesites/runtime';
import { RichTextContent, useContentToken } from '@vibesites/runtime/react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { useRevealStyles } from '../hooks/useRevealStyles';

function hasValue(val: string | null | undefined): val is string {
  if (!val) return false;
  const normalized = val.trim().toLowerCase();
  return normalized !== '' && normalized !== 'false' && normalized !== 'null' && normalized !== 'undefined';
}

/**
 * Short pricing disclaimer / verbiage shown above the floor-plans
 * ApartmentSync embed. Bound to `custom_pricing_verbiage`; hides itself
 * when the field is empty.
 */
export function PricingVerbiage() {
  useRevealStyles();
  const sectionRef = useScrollReveal<HTMLElement>();

  const pricingVerbiage = useContentToken('pricingverbiage.text');

  if (!hasValue(pricingVerbiage)) return null;

  return (
    <section
      ref={sectionRef as React.RefObject<HTMLElement>}
      className="reveal-fade-up pt-8 pb-1 md:pt-12 md:pb-2 bg-[var(--vibe-color-background)]"
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <RichTextContent
          path="pricingverbiage.text"
          as="p"
          className="font-body text-sm sm:text-base leading-relaxed text-[var(--vibe-color-text-muted)]"
        />
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'PricingVerbiage',
  displayName: 'Pricing Verbiage',
  tokens: {
    'pricingverbiage.text': {
      label: 'Pricing Verbiage',
      type: 'richtext',
      defaultField: 'custom_pricing_verbiage',
    },
  },
};

(PricingVerbiage as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default PricingVerbiage;
